// extracted by mini-css-extract-plugin
export var productImage = "_n0-1";
export var viewLink = "_n0-2";
export var wishlistItem = "_n0-0";